import React, { useState, forwardRef, useRef } from 'react';
import TextField from '@material-ui/core/TextField';
import MaskedInput from 'react-text-mask';

const TextMaskCustom = forwardRef(function TextMaskCustom(props, ref) {
	const { inputRef, ...other } = props;

	return (
		<MaskedInput
			{...other}
			ref={(maskedRef) => {
				if (typeof inputRef === 'function') {
					inputRef(maskedRef ? maskedRef.inputElement : null);
				} else if (inputRef) {
					inputRef.current = maskedRef ? maskedRef.inputElement : null;
				}
			}}
			showMask
			guide={false}
			placeholderChar={'\u2000'}
			mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
		/>
	);
});

const PhoneValidator = ({ helperText, errorText, onChange, value = '', ...rest }) => {
	const [isValid, setIsValid] = useState(true);
	const inputRef = useRef(null);

	const validatePhoneNumber = (phoneNumber) => {
		const phoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/;
		return phoneRegex.test(phoneNumber);
	};

	const handleChange = (event) => {
		const inputValue = event.target.value;
		setIsValid(validatePhoneNumber(inputValue));
		if (onChange) {
			onChange(event);
		}
	};
	return (
		<TextField
			{...rest}
			type="tel"
			error={!isValid}
			helperText={!isValid ? errorText || 'Invalid phone number format' : helperText}
			InputProps={{
				inputComponent: TextMaskCustom,
			}}
			inputRef={inputRef}
			value={value}
			onChange={handleChange}
		/>
	);
}

export default PhoneValidator